import 'angular-material/angular-material.css';
import 'angular-material-data-table/dist/md-data-table.css';
import 'font-awesome/css/font-awesome.css';
import 'angular-ui-tree/dist/angular-ui-tree.css';
import 'highcharts/css/highcharts.css';



// WEBPACK FOOTER //
// ./vendor-styles.js